
{
  "familyId": "TAA-SOORT-WW",
  "questions": [
    {
      "id": "TAA-SOORT-WW-001",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het werkwoord in deze zin?\n'De kinderen spelen buiten in de tuin.'",
      "context": null,
      "options": ["spelen", "kinderen", "buiten", "tuin"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Wat is een werkwoord?", "content": "Een werkwoord beschrijft wat iemand doet, voelt of is. Je kunt het herkennen door te vragen: 'Wat doet/is/heeft...?' Het antwoord is het werkwoord.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_herkennen_basis",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Het werkwoord beschrijft wat de kinderen doen. Vraag: 'Wat doen de kinderen?' Antwoord: 'spelen'. Dus 'spelen' is het werkwoord. 'Kinderen' is een zelfstandig naamwoord, 'buiten' en 'tuin' zijn bijwoord/zelfstandig naamwoord.",
        "distractorExplanations": {
          "0": "Correct! 'Spelen' is het werkwoord: het beschrijft wat de kinderen doen.",
          "1": "Fout: 'kinderen' is een zelfstandig naamwoord (het antwoord op 'wie?'). Het werkwoord beschrijft wat ze doen: spelen.",
          "2": "Fout: 'buiten' is een bijwoord (het antwoord op 'waar?'). Het werkwoord beschrijft wat ze doen: spelen.",
          "3": "Fout: 'tuin' is een zelfstandig naamwoord (een ding/plaats). Het werkwoord beschrijft wat ze doen: spelen."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-002",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het werkwoord in deze zin?\n'Mijn moeder bakt elke zondag een taart.'",
      "context": null,
      "options": ["bakt", "moeder", "zondag", "taart"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Werkwoord vinden", "content": "Vraag: 'Wat doet mijn moeder?' → bakt. Dat is het werkwoord. Werkwoorden beschrijven een handeling, toestand of gevoel.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_handeling",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Vraag: 'Wat doet mijn moeder?' Antwoord: 'bakt'. Dus 'bakt' is het werkwoord. Het beschrijft de handeling (bakken).",
        "distractorExplanations": {
          "0": "Correct! 'Bakt' is het werkwoord: het beschrijft wat de moeder doet.",
          "1": "Fout: 'moeder' is een zelfstandig naamwoord (een persoon). Het werkwoord beschrijft wat ze doet: bakt.",
          "2": "Fout: 'zondag' is een zelfstandig naamwoord (een dag). Het werkwoord beschrijft wat ze doet: bakt.",
          "3": "Fout: 'taart' is een zelfstandig naamwoord (een ding). Het werkwoord beschrijft wat ze doet: bakt."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-003",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Hoeveel werkwoorden staan er in deze zin?\n'De hond rent snel en blaft luid.'",
      "context": null,
      "options": ["2", "1", "3", "0"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meerdere werkwoorden", "content": "Een zin kan meerdere werkwoorden hebben. Zoek alle woorden die beschrijven wat iemand doet: rent (wat doet de hond?) en blaft (wat doet de hond nog meer?).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_meerdere",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "In deze zin zijn twee werkwoorden: 'rent' (wat doet de hond?) en 'blaft' (wat doet de hond nog meer?). 'Snel' en 'luid' zijn bijwoorden (ze beschrijven hoe).",
        "distractorExplanations": {
          "0": "Correct! Er zijn twee werkwoorden: 'rent' en 'blaft'.",
          "1": "Fout: er zijn twee werkwoorden. Vraag: 'Wat doet de hond?' → rent. 'Wat doet de hond nog meer?' → blaft.",
          "2": "Fout: er zijn maar twee werkwoorden (rent en blaft). 'Snel' en 'luid' zijn bijwoorden, geen werkwoorden.",
          "3": "Fout: er zijn werkwoorden in deze zin. Vraag: 'Wat doet de hond?' → rent en blaft."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-004",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN werkwoord?",
      "context": null,
      "options": ["snel", "rennen", "slapen", "lachen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Werkwoord of niet?", "content": "Werkwoorden beschrijven een handeling, toestand of gevoel: rennen, slapen, lachen, zijn, hebben.\nBijvoeglijke naamwoorden beschrijven een eigenschap: snel, groot, mooi.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_onderscheid",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "'Snel' is een bijvoeglijk naamwoord (het beschrijft een eigenschap: hoe snel?). 'Rennen', 'slapen' en 'lachen' zijn werkwoorden (ze beschrijven handelingen).",
        "distractorExplanations": {
          "0": "Correct! 'Snel' is een bijvoeglijk naamwoord, geen werkwoord. Het beschrijft een eigenschap.",
          "1": "Fout: 'rennen' is een werkwoord. Het beschrijft een handeling (wat doe je?).",
          "2": "Fout: 'slapen' is een werkwoord. Het beschrijft een toestand (wat doe je?).",
          "3": "Fout: 'lachen' is een werkwoord. Het beschrijft een handeling (wat doe je?)."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-005",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het werkwoord in deze zin?\n'Het kleine meisje is heel gelukkig.'",
      "context": null,
      "options": ["is", "meisje", "kleine", "gelukkig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn als werkwoord", "content": "'Zijn' (ben/bent/is/zijn) is ook een werkwoord! Het beschrijft een toestand. Vraag: 'Wat is het meisje?' → is gelukkig. 'Is' is het werkwoord.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_zijn_toestand",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "'Is' is het werkwoord in deze zin. 'Zijn' (ben/bent/is/zijn) is een werkwoord dat een toestand beschrijft. 'Kleine' is een bijvoeglijk naamwoord, 'meisje' is een zelfstandig naamwoord, 'gelukkig' is een bijvoeglijk naamwoord.",
        "distractorExplanations": {
          "0": "Correct! 'Is' is het werkwoord. Het beschrijft de toestand van het meisje.",
          "1": "Fout: 'meisje' is een zelfstandig naamwoord (een persoon). Het werkwoord is 'is'.",
          "2": "Fout: 'kleine' is een bijvoeglijk naamwoord (het beschrijft hoe het meisje eruitziet). Het werkwoord is 'is'.",
          "3": "Fout: 'gelukkig' is een bijvoeglijk naamwoord (een eigenschap). Het werkwoord is 'is'."
        }
      }
    }
  ]
}
